/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateQuestionTypesControllerFindOneQueryResponse, TemplateQuestionTypesControllerFindOnePathParams, TemplateQuestionTypesControllerFindOneQueryParams, TemplateQuestionTypesControllerFindOne400, TemplateQuestionTypesControllerFindOne401, TemplateQuestionTypesControllerFindOne403, TemplateQuestionTypesControllerFindOne404 } from "../../models/checklistsController/TemplateQuestionTypesControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { templateQuestionTypesControllerFindOne } from "../../clients/checklistsService/templateQuestionTypesControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const templateQuestionTypesControllerFindOneQueryKey = (id: TemplateQuestionTypesControllerFindOnePathParams["id"], params: TemplateQuestionTypesControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/checklist-template-question-types/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type TemplateQuestionTypesControllerFindOneQueryKey = ReturnType<typeof templateQuestionTypesControllerFindOneQueryKey>;
export function templateQuestionTypesControllerFindOneQueryOptions(id: TemplateQuestionTypesControllerFindOnePathParams["id"], params?: TemplateQuestionTypesControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = templateQuestionTypesControllerFindOneQueryKey(id, params);
  return queryOptions<TemplateQuestionTypesControllerFindOneQueryResponse, ResponseErrorConfig<TemplateQuestionTypesControllerFindOne400 | TemplateQuestionTypesControllerFindOne401 | TemplateQuestionTypesControllerFindOne403 | TemplateQuestionTypesControllerFindOne404>, TemplateQuestionTypesControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return templateQuestionTypesControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a specific checklist template question type by ID
 * {@link /api/v1/checklist-template-question-types/:id}
 */
export function useTemplateQuestionTypesControllerFindOne<TData = TemplateQuestionTypesControllerFindOneQueryResponse, TQueryData = TemplateQuestionTypesControllerFindOneQueryResponse, TQueryKey extends QueryKey = TemplateQuestionTypesControllerFindOneQueryKey>(id: TemplateQuestionTypesControllerFindOnePathParams["id"], params?: TemplateQuestionTypesControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<TemplateQuestionTypesControllerFindOneQueryResponse, ResponseErrorConfig<TemplateQuestionTypesControllerFindOne400 | TemplateQuestionTypesControllerFindOne401 | TemplateQuestionTypesControllerFindOne403 | TemplateQuestionTypesControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? templateQuestionTypesControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...templateQuestionTypesControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TemplateQuestionTypesControllerFindOne400 | TemplateQuestionTypesControllerFindOne401 | TemplateQuestionTypesControllerFindOne403 | TemplateQuestionTypesControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}